import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const ProjectDetailPage = lazy(() => import("../pages/ProjectDetailPage"));
const WorkspaceDetailPage = lazy(() => import("../pages/WorkspaceDetailPage"));
const WorkspacesPage = lazy(() => import("../pages/WorkspacesPage"));

export function WorkspacesRoutes() {
  return (
    <Switch>
      <Route exact path="/workspaces" component={WorkspacesPage} />
      <Route path="/workspaces/:owner/:project" component={ProjectDetailPage} />
      <Route path="/workspaces/:owner" component={WorkspaceDetailPage} />
    </Switch>
  );
}
